import 'leaflet/dist/leaflet.css';
import { useIntl } from '@amazeelabs/react-framework-bridge/react-intl';
import clsx from 'clsx';
import L from 'leaflet';
import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { u as useSetMediaQuery, H as Heading, l as listBullet } from './index-410bd12b.js';
import '@amazeelabs/react-framework-bridge';
import '@loadable/component';
import 'hast-util-is-element';
import 'unist-util-visit';
import 'hast-util-select';
import '@headlessui/react';
import '@heroicons/react/outline';
import 'framer-motion';
import '@amazeelabs/react-framework-bridge/formik';
import 'zustand';
import '@heroicons/react/solid';
import '@lottiefiles/react-lottie-player';
import '@amazeelabs/react-framework-bridge/storybook';
import 'react-body-classname';
import 'date-fns/locale/de';
import 'date-fns/locale/en-GB';
import 'date-fns/locale/fr';
import 'date-fns/locale/it';
import '@amazeelabs/molecules';
import 'react-tooltip';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker';
import 'lodash';
import '@amazeelabs/silverback-iframe';
import 'swiper';
import 'swiper/react';
import 'use-debounce';
import 'react-use-measure';
import 'swiper/css';
import '@amazeelabs/react-framework-bridge/gatsby';

const localeStyleMap = {
  de: 'clr662o9200bj01o7fe6tdrh6',
  en: 'clr666icn00bl01o7e22o524y',
  fr: 'clr665xxd01ha01qu092dd39d',
  it: 'clr665d6m01fp01o99gqdasm7',
  'pt-pt': 'clr664n0400bk01o79018bqci',
  es: 'clr663tmv01ie01qra4tka6ll'
};
function customIcon(customIconUrl, iconSize) {
  return new L.Icon({
    iconUrl: customIconUrl,
    iconSize: iconSize,
    iconAnchor: [iconSize[0] / 2, iconSize[1]]
  });
}
const getMapBounds = markers => {
  const {
    minLng,
    maxLng,
    minLat,
    maxLat
  } = markers.reduce((previousValue, currentValue) => ({
    minLng: Math.min(previousValue.minLng, currentValue.position.lng || 0),
    maxLng: Math.max(previousValue.maxLng, currentValue.position.lng || 0),
    minLat: Math.min(previousValue.minLat, currentValue.position.lat || 0),
    maxLat: Math.max(previousValue.maxLat, currentValue.position.lat || 0)
  }), {
    minLng: 180,
    maxLng: -180,
    minLat: 90,
    maxLat: -90
  });
  // Return the top-left and the bottom right corners of the bounds, but add
  // some extra space in case the markers are just of the edge of the map.
  return {
    corner1: {
      lat: Math.min(maxLat + 0.05, 90),
      lng: Math.max(minLng - 0.05, -180)
    },
    corner2: {
      lat: Math.max(minLat - 0.05, -90),
      lng: Math.min(maxLng + 0.05, 180)
    }
  };
};
function Map({
  markers,
  Title,
  center,
  scrollWheelZoom = false,
  centerByMapBounds = true,
  zoom = 11,
  isRedesignedPopup = true,
  mapSize = 'DEFAULT'
}) {
  const intl = useIntl();
  function getMarkerIcon(pinType) {
    if (pinType === 'bio') {
      return customIcon('/bio-pin.svg', [32.723, 42.191]);
    } else if (pinType === 'sos') {
      return customIcon('/sos-pin.svg', [32.723, 42.191]);
    } else {
      return customIcon('/map-marker-lg.svg', [44, 54]);
    }
  }
  const mapBounds = centerByMapBounds ? getMapBounds(markers) : undefined;
  const isMobile = useSetMediaQuery() === 'mobile';
  const [popupOffset, setPopupOffset] = useState(0);
  useEffect(() => {
    if (!isMobile && isRedesignedPopup) setPopupOffset(420);else setPopupOffset(0);
  }, [isMobile, isRedesignedPopup]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'container-page my-10',
    "data-chromatic": "ignore"
  }, Title ? /*#__PURE__*/React.createElement("div", {
    className: 'container-content my-5 sm:my-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'md:inline-block'
  }, /*#__PURE__*/React.createElement(Heading, {
    Heading: Title
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: 'container-content'
  }, /*#__PURE__*/React.createElement(MapContainer, {
    center: center,
    className: clsx({
      'h-[400px] md:h-[500px]': mapSize === 'DEFAULT',
      'h-[600px] md:h-[900px]': mapSize === 'LARGE'
    }),
    zoom: !mapBounds ? zoom : undefined,
    bounds: mapBounds && [[mapBounds.corner1.lat, mapBounds.corner1.lng], [mapBounds.corner2.lat, mapBounds.corner2.lng]],
    scrollWheelZoom: scrollWheelZoom
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: "\xA9 <a href=\"https://www.mapbox.com/about/maps/\">Mapbox</a> \xA9 <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a>",
    url: `https://api.mapbox.com/styles/v1/caritas-schweiz/${localeStyleMap[intl.locale]}/tiles/{tileSize}/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiY2FyaXRhcy1zY2h3ZWl6IiwiYSI6ImNscjY5OW44ZTBlZWMya3BxY2hxbDdsN3oifQ.glMk66CI3vj5crIOr4vVrw`
  }), /*#__PURE__*/React.createElement(MarkerClusterGroup, {
    chunkedLoading: true,
    spiderLegPolylineOptions: {
      color: '#222'
    },
    polygonOptions: {
      opacity: 0,
      fillOpacity: 0
    }
  }, markers.map(({
    position,
    pinType,
    Content,
    Link,
    MarkerImage
  }, index) => /*#__PURE__*/React.createElement(Marker, {
    key: index,
    position: position,
    icon: getMarkerIcon(pinType)
  }, !popupOffset ? /*#__PURE__*/React.createElement(Popup
  /* eslint-disable-next-line tailwindcss/no-custom-classname */, {
    className: clsx({
      'redesigned-popup': isRedesignedPopup,
      'taller-popup': mapSize === 'LARGE'
    }),
    key: "original-popup"
  }, /*#__PURE__*/React.createElement(PopupContent, {
    content: Content,
    link: Link,
    markerImage: MarkerImage,
    isRedesigned: isRedesignedPopup
  })) : /*#__PURE__*/React.createElement(Popup, {
    offset: [popupOffset, 50]
    /* eslint-disable-next-line tailwindcss/no-custom-classname */,
    className: clsx({
      'md:!left-5  redesigned-popup': isRedesignedPopup,
      'taller-popup': mapSize === 'LARGE'
    }),
    key: "redesigned-popup"
  }, /*#__PURE__*/React.createElement(PopupContent, {
    content: Content,
    link: Link,
    markerImage: MarkerImage,
    isRedesigned: isRedesignedPopup
  }))))))));
}
const PopupContent = ({
  link: Link,
  markerImage: MarkerImage,
  isRedesigned,
  content: Content
}) => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('flex min-h-[110px]', {
      'border-l-4 border-red-500': isRedesigned
    })
  }, MarkerImage ? /*#__PURE__*/React.createElement("div", {
    className: 'w-28 shrink-0'
  }, /*#__PURE__*/React.createElement(MarkerImage, {
    className: 'h-full max-w-full object-cover'
  })) : null, /*#__PURE__*/React.createElement("div", {
    /* eslint-disable-next-line tailwindcss/no-custom-classname */
    className: clsx('prose  !leading-snug sm:prose-lg md:prose-xl', {
      'pt-5 pb-6 pl-4': !isRedesigned,
      'py-10 md:pt-12 md:pb-16 pl-8 me-0': isRedesigned
    })
  }, /*#__PURE__*/React.createElement(Content, {
    plugins: [listBullet],
    classNames: {
      a: `!text-red-500 hover:!text-red-600 font-light no-underline transition duration-300 hover:shadow-[inset_0_-30px_0_0_rgba(219,0,27,0.15)] focus`,
      ul: 'list-none'
    }
  }), Link ? /*#__PURE__*/React.createElement(Link, {
    className: 'mt-3 block text-sm font-bold uppercase !text-red-500 no-underline'
  }, intl.formatMessage({
    id: "TdTXXf",
    defaultMessage: [{
      "type": 0,
      "value": "Learn more"
    }]
  })) : null));
};

export { Map as default };
